import { BlockTime } from "./BlockPosition.js";

export class TempoObject {
    constructor(jsonStructure) {
        this.start_time = new BlockTime(jsonStructure.start_time);
        this.tempo = jsonStructure.tempo;
    }
}